module.exports = __webpack_public_path__ + "static/media/14.333e15bf.JPG";